var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"label":"Asset Id"},model:{value:(_vm.assetId),callback:function ($$v) {_vm.assetId=$$v},expression:"assetId"}}),_c('v-btn',{attrs:{"depressed":""},on:{"click":_vm.fetchMuxAsset}},[_vm._v("Download")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }